import path from './path';

const PROXY_CLUSTER = 'nightly';
const clusterToHostMap = {
  in: 'incrm.cc.capillarytech.com',
  sg: 'sgcrm.cc.capillarytech.com',
  eu: 'eucrm.cc.capillarytech.com',
  tata: 'tatacrm.cc.capillarytech.com',
  us: 'uscrm.cc.capillarytech.com',
  staging: 'crm-staging-new.cc.capillarytech.com',
  nightly: 'nightly.intouch.capillarytech.com',
  devenv: 'dev.intouch.capillarytech.com',
};
const HOST_NAME = clusterToHostMap[PROXY_CLUSTER] || clusterToHostMap.nightly;

const config = {
  production: {
    api_endpoint: '/intouch-ui/api/v1',
    auth_endpoint: '/arya/api/v1',
    login_url: '/auth/login',
    new_login_url: '/auth/v2/login',
    otp_url: '/auth/v2/otp',
    forgot_password_url: '/auth/v2/forgotPassword',
    set_password_url: '/auth/v2/password/:type',
    account_locked_url: '/auth/v2/:type/locked',
    bi_api_endpoint: '/arya/api/v1/bi',
    campaigns_api_endpoint: '/iris/v2',
    loyalty_api_endpoint: '/loyalty/api/v1',
    org_settings_api_endpoint: '/arya/api/v1/org-settings',
    incentives_api_endpoint: '/incentives/api/v1',
    coupon_api_endpoint: '/coupon/api/v1',
    adiona_api_endpoint: '/adiona/api/v1',
    emf_api_endpoint: '/loyalty/emf/v1',
    intouch_api_v3_endpoint: '/intouch-api/v3',
    dashboard_url: path.publicPath,
    extensions_url: `${path.publicPath}/extensions/index`,
    logout_url: '/auth/logout',
    nfs_endpoint: '/arya/api/v1/nfs',
  },
  development: {
    api_endpoint: `https://${HOST_NAME}/intouch-ui/api/v1`,
    auth_endpoint: `https://${HOST_NAME}/arya/api/v1`,
    bi_api_endpoint: `https://${HOST_NAME}/arya/api/v1/bi`,
    campaigns_api_endpoint: `https://${HOST_NAME}/iris/v2`,
    loyalty_api_endpoint: `https://${HOST_NAME}/loyalty/api/v1`,
    org_settings_api_endpoint: `https://${HOST_NAME}/arya/api/v1/org-settings`,
    incentives_api_endpoint: `https://${HOST_NAME}/incentives/api/v1`,
    coupon_api_endpoint: `https://${HOST_NAME}/coupon/api/v1`,
    adiona_api_endpoint: `https://${HOST_NAME}/adiona/api/v1`,
    emf_api_endpoint: `https://${HOST_NAME}/loyalty/emf/v1`,
    intouch_api_v3_endpoint: `https://${HOST_NAME}/intouch-api/v3`,
    login_url: '/login',
    new_login_url: '/auth/v2/login',
    otp_url: '/auth/v2/otp',
    forgot_password_url: '/auth/v2/forgotPassword',
    set_password_url: '/auth/v2/password/:type',
    account_locked_url: '/auth/v2/:type/locked',
    dashboard_url: path.publicPath,
    extensions_url: `${path.publicPath}/extensions/index`,
    nfs_endpoint: `https://${HOST_NAME}/arya/api/v1/nfs`,
  },
  testing: {
    api_endpoint: '',
    auth_endpoint: '',
    login_url: '',
  },
};

export default config;

export const newrelicConfig = {
  enabled: true,
  licenseKey: '082da40fff',
  environments: {
    nightly: { appId: '718437928' },
    staging: { appId: '718437928' },
    ushc: { appId: '718437928' },
    apac: { appId: '718437928' },
    'north-america': { appId: '718437928' },
    apac2: { appId: '718437928' },
    tata: { appId: '718437928' },
    sea: { appId: '718437928' },
    eu: { appId: '718437928' },
  },
};
